import { createSlice } from "@reduxjs/toolkit";


export const idSpotSlice = createSlice({
    name: 'idSpot',
    initialState:{},
    reducers: { //modify the selected spot in global state
        setIdSpot: (currentState, action) => {
            
            return action.payload //action.payload is the new spot id sent by the dispatch call

        }
    }
});